import { render, staticRenderFns } from "./edit_sbquest.vue?vue&type=template&id=41637a97&scoped=true&"
import script from "./edit_sbquest.vue?vue&type=script&lang=js&"
export * from "./edit_sbquest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41637a97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41637a97')) {
      api.createRecord('41637a97', component.options)
    } else {
      api.reload('41637a97', component.options)
    }
    module.hot.accept("./edit_sbquest.vue?vue&type=template&id=41637a97&scoped=true&", function () {
      api.rerender('41637a97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/scheck/edit_sbquest.vue"
export default component.exports